import userService from '@/services/API/user/index';

export default {
  name: 'user',
  namespaced: true,
  state: {
    cache: {},
  },
  getters: {
    getCachedUser: (state) => (id) => state.cache[id] || {},
  },
  actions: {
    async loadUsers({ commit, getters }, ids) {
      if (!ids?.length) return;

      // check if has ids in store
      const idsInStore = ids.filter((id) => Object.keys(getters.getCachedUser(id)).length === 0);
      const newIds = new Set([...idsInStore]);

      if (!newIds.size) return;

      const params = {
        'search[id]': Array.from(newIds).join(','),
        'per-page': newIds.length,
        expand: 'profile,certificate,directory_attributes',
      };

      const response = await userService.getPublicUsers(params);
      commit('ADD_USERS', response.data.data);

      setTimeout(() => {
        commit('CLEAR_USERS');
      }, 10000);
    },
  },
  mutations: {
    ADD_USERS(state, data) {
      const newCache = {};
      (data || []).forEach((user) => {
        newCache[user.id] = user;
      });
      state.cache = { ...state.cache, ...newCache };
    },

    CLEAR_USERS(state) {
      const keys = Object.keys(state.cache);
      if (keys.length < 50) return;

      const newCache = { ...state.cache };

      for (let i = 0; i < 10; i++) {
        delete newCache[keys[i]];
      }

      state.cache = { ...newCache };
    },

  },
};
